import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

import { cn } from '@/utils/cn';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  className?: string;
  itemClassName?: string;
  triggerClassName?: string;
  contentClassName?: string;
  accentColor?: string;
}

export function FaqAccordion({ items, className, itemClassName, triggerClassName, contentClassName, accentColor }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className={cn('space-y-3', className)}>
      {items.map((item, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={i} className={cn('overflow-hidden rounded-xl border border-white/[0.06] bg-[#12141a]', itemClassName)}>
            <button type='button' className={cn('flex w-full items-center justify-between px-6 py-5 text-start text-base font-semibold text-white transition-colors', triggerClassName)} onClick={() => setOpenIndex(isOpen ? null : i)}>
              {item.q}
              <ChevronDown className={cn('ms-2 h-5 w-5 shrink-0 transition-transform duration-200', isOpen && 'rotate-180')} style={{ color: accentColor ?? '#929298' }} />
            </button>
            <div className={cn('grid transition-all duration-200', isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]')}>
              <div className='overflow-hidden'>
                <p className={cn('px-6 pb-5 leading-relaxed text-[#929298]', contentClassName)}>{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
